<script lang="ts">
  export let text: string
</script>

{@html text}
